import { Fragment } from "react";
import { Link } from "react-router-dom";
import { FaFacebook } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { FaPinterest } from 'react-icons/fa';
const Footer = () => {
  return (
    <Fragment>
      <div className="bg-[#0a0a0a] px-4 py-8 border-t border-zinc-800/50 mt-auto">
        <div className="container mx-auto md:px-28">
          <div className="md:flex md:justify-between items-center">
            <div className="flex justify-center md:justify-start mb-6 md:mb-0">
              <Link to="/" className="flex items-center">
                <span className="text-gray-400 hover:text-white transition-colors duration-300 text-lg uppercase tracking-widest font-light">
                  Suresh Gosavi
                </span>
              </Link>
            </div>

            <div className="flex flex-row justify-center md:justify-end space-x-6">
              <a href="https://www.facebook.com/suresh.gosavi.10" rel="noreferrer" target="_blank" className="text-xl text-zinc-500 hover:text-white transition-colors duration-300">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/sureshgosavi.24" rel="noreferrer" target="_blank" className="text-xl text-zinc-500 hover:text-white transition-colors duration-300">
                <FaInstagram />
              </a>
              <a href="https://pin.it/3mswTqaL9" rel="noreferrer" target="_blank" className="text-xl text-zinc-500 hover:text-white transition-colors duration-300">
                <FaPinterest />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
